/**
 * Changes the subtotal text.
 */

const subtotalContainer = document.getElementById('product-addons-total');

const handleMutations = function handleSubtotalMutations() {
  const subtotalItems = subtotalContainer.getElementsByTagName('li');
  for (let i = 0; i < subtotalItems.length; i += 1) {
    const subtotalItem = subtotalItems[i];
    const itemNameElement = subtotalItem.getElementsByTagName('strong')[0];
    if (itemNameElement) {
      if (i === 0) {
        let plansSelect = document.getElementById('access-plan');
        if (!plansSelect) {
          plansSelect = document.getElementById('pa_access-plan');
        }
        const selectedOption = plansSelect.options[plansSelect.selectedIndex].text;
        itemNameElement.textContent = selectedOption;
      } else {
        const itemName = itemNameElement.textContent.split(' - ').slice(-1);
        itemNameElement.textContent = itemName;
      }
    } else {
      /* Remove "Subtotal" */
      const priceElement = subtotalItem.getElementsByTagName('p')[0];
      priceElement.removeChild(priceElement.firstChild);
    }
  }
};

const observer = new MutationObserver(handleMutations);
observer.observe(subtotalContainer, { childList: true });
